import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Image from 'material-ui-image'
import {Link} from "react-router-dom";
import ContactUs from "./ContactUs";
import Divider from "@material-ui/core/Divider";
//import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER, RECAPTCHASITEKEY} from "../../utils/MainConstants";
import * as MainConstants from "../../utils/MainConstants";
//import GridBase from "@material-ui/core/Grid";

import InputMask from 'react-input-mask'
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import {AES} from "crypto-js";
import ReCAPTCHA from "react-google-recaptcha";


/*const Grid = styled(GridBase)`
  .MuiGrid-root {
    flex-grow: 1;
  }*/

const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)
  
});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  /*button: {
    margin: theme.spacing.unit,
  },*/
  buttonrecaptcha: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
   // backgroundColor: "#e2680d",
    color: "black",
    textTransform: "unset !important",
    width: '20%',
    fontSize:18,
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
    //backgroundColor: "#e2680d",
    border:'2px solid green',
    borderColor:'black',
    //backgroundColor:'#D1E1EC',
    backgroundColor:'#9db7cf',
    color: "black",
    textTransform: "unset !important",
    width: '20%',
    fontSize:18,
    '&:hover': {
      backgroundColor: 'white', // Background color on hover
      color: 'black', // Optional: Change text color on hover
    },
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },
});


class SaveTime extends Component {
  
  
  
  state = {
    age: '',
    name: 'hai',
    cellphone:'',
    serviceCellphone:'',
    code:'',
    showNewCodeErrorDialog:false,
    showCodeToCellphoneErrorDialog:false,
    showNewCodeSuccessDialog:false,
    email:'',
    password:'',
    serviceEmail:'',
    servicePassword:'',
    showPassword:false,
    showServicePassword:false,
    captchaValue:"",
    captchaValuePromo:"",
  };
  
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  
  constructor(props) {
    super(props);
    this.towAgentClick = this.towAgentClick.bind(this);
    this.vehicleOwnerClick = this.vehicleOwnerClick.bind(this);
    //this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleCellphoneChange = this.handleCellphoneChange.bind(this);
    this.showResponseOkClose = this.showResponseOkClose.bind(this);
    this.onSendCodeToCellPhonePressed = this.onSendCodeToCellPhonePressed.bind(this);
    this.senCodeToCellphoneServer = this.senCodeToCellphoneServer.bind(this);
    this.showCodeToCellphoneError = this.showCodeToCellphoneError.bind(this);
    this.handleNewPasswordErrorClose = this.handleNewPasswordErrorClose.bind(this);
    this.handleResponseOkClose = this.handleResponseOkClose.bind(this);
    this.encrypt = this.encrypt.bind(this);
    
    
    /*this.onSubmitCodePressed = this.onSubmitCodePressed.bind(this);
    this.sendNewCodeServer = this.sendNewCodeServer.bind(this);
    this.getArrayOfNewCode = this.getArrayOfNewCode.bind(this);*/
    
    this.handleNewCodeErrorClose = this.handleNewCodeErrorClose.bind(this);
    this.showNewCodeError=this.showNewCodeError.bind(this);
    this.handleNewCodeSuccessClose = this.handleNewCodeSuccessClose.bind(this);
    this.showNewCodeSuccess=this.showNewCodeSuccess.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleOptoutForPromotional = this.handleOptoutForPromotional.bind(this);
    this.handleOptoutForService = this.handleOptoutForService.bind(this);
    
    this.handleServiceEmailChange = this.handleServiceEmailChange.bind(this);
    this.handleServicePasswordChange = this.handleServicePasswordChange.bind(this);
    this.handleServiceCellphoneChange = this.handleServiceCellphoneChange.bind(this);
    this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
    this.handleClickShowServicePassword = this.handleClickShowServicePassword.bind(this);
    this.handleMouseDownPassword = this.handleMouseDownPassword.bind(this);
    this.handleCaptchaChange= this.handleCaptchaChange.bind(this);
    this.handleCaptchaChangePromo= this.handleCaptchaChangePromo.bind(this);
    this.recaptchaRef = React.createRef();
    this.recaptchaRefPromo = React.createRef();
    
    
  }
  
  handleCaptchaChange = (value) => {
    this.setState({ captchaValue: value });
  };
  
  handleCaptchaChangePromo = (value) => {
    this.setState({ captchaValuePromo: value });
  };
  
  towAgentClick(){
    //alert("was called") ;
    this.props.towAgentConfigCall();
    
  }
  
  vehicleOwnerClick(){
    let { loginAction } = this.props;
    //this.props.auth.login();
    loginAction();
    //alert("was called") ;
    //this.props.vehicleOwnerConfigCall();
    
  }
  
  handleSubmit() {
    
    
    /*let {saveATowCompanyDriver} = this.props;
    
    var tempStream = this.state.selectedTowCompanyDriver;
    
    
    saveATowCompanyDriver(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
    this.refresh();*/
    this.onSendCodeToCellPhonePressed();
    
  };
  
  handleCellphoneChange(event) {
    //event.preventDefault();
    this.setState( {cellphone: event.target.value});
  }
  
  
  handleServiceCellphoneChange(event) {
    //event.preventDefault();
    this.setState( {serviceCellphone: event.target.value});
  }
  handleCodeChange(event) {
    //event.preventDefault();
    this.setState( {code: event.target.value});
  }
  
  /*handleOptoutForPromotional(){
    this.onSendCodeToCellPhonePressed( this.state.email, this.state.password, this.state.cellphone,'promotion');
  }*/
  
  
  
  
  handleOptoutForPromotional(event) {
    //let { loginToPlatewiz} = this.props;
    event.preventDefault();
    //console.log('Form submitted with reCAPTCHA:', this.state.captchaValuePromo);
    if (this.state.captchaValuePromo) {
      
      this.onSendCodeToCellPhonePressed( this.state.email, this.state.password, this.state.cellphone,'promotion',this.state.captchaValuePromo);
      // To reset reCAPTCHA manually
      this.recaptchaRefPromo.current.reset();
    } else {
      // Handle case where reCAPTCHA is not solved
      console.log('Please complete the reCAPTCHA');
      alert('Please complete the reCAPTCHA first');
    }
  }
  
  /*handleOptoutForService(){
    this.onSendCodeToCellPhonePressed( this.state.serviceEmail, this.state.servicePassword, this.state.serviceCellphone,'service');
  }*/
  
  handleOptoutForService(event) {
    //let { loginToPlatewiz} = this.props;
    event.preventDefault();
    console.log('Form submittedin opout  with reCAPTCHA:', this.state.captchaValue);
    if (this.state.captchaValue) {
      
      this.onSendCodeToCellPhonePressed( this.state.serviceEmail, this.state.servicePassword, this.state.serviceCellphone,'service',this.state.captchaValue );
      // To reset reCAPTCHA manually
      this.recaptchaRef.current.reset();
    } else {
      // Handle case where reCAPTCHA is not solved
      console.log('Please complete the reCAPTCHA');
      alert('Please complete the reCAPTCHA first');
    }
  }
  
  onSendCodeToCellPhonePressed(argEmail, argPassword, argCellphone, argType, argReCaptchaToken) {
    //this.senCodeToCellphoneServer(DEFAULT_VESPAAN_SERVER.url,  this.state.email, this.state.password, this.state.cellphone, argType);
    this.senCodeToCellphoneServer(DEFAULT_VESPAAN_SERVER.url,  argEmail, argPassword, argCellphone, argType, argReCaptchaToken);
  }
  senCodeToCellphoneServer( argURL, argEmail, argPassword, argPhone, argType, argReCaptchaToken){
    // const { navigate } = this.props.navigation;
    var self=this;
    
    
    if((argURL != null) || (argURL.length != 0)){
      axios.all(self.getArrayOfNewPassword(argURL, argEmail, argPassword, argPhone, argType, argReCaptchaToken )).then(function(responses){
        //console.log(responses[0].data);
        self.showResponseOkClose();
        //self.recaptchaRef.current.reset();
        
      }, function(err) {
        console.log(err);
        console.log("Some error occurred on new password request  to server " + err.message +  " the URL is " + argURL );
        //self.errorMessage = err.response.data.message;
         self.showCodeToCellphoneError();
         //self.recaptchaRef.current.reset();
        //self.showResponseOkClose();
        //reject(err);
      });
    }
  }
  
  getArrayOfNewPassword(argURL, argEmail, argPassword, argPhone, argType, argReCaptchaToken){
    
    let baseUrl = argURL+"optout?type="+argType+"&recaptchatoken="+argReCaptchaToken;
    console.log(" on newpassword request url  is " + baseUrl );
    
    var arrayOfGets = [];
    if(argURL != null) {
      let enctyptedPasswordd = this.encrypt(argPassword);
      console.log("Encrypted Password is  "+enctyptedPasswordd );
      arrayOfGets.push(axios.post(baseUrl,{ "username": argEmail,
        "password": enctyptedPasswordd, "cellphone":argPhone} ));
    }
    return arrayOfGets;
  }
  
  encrypt(value) {
    console.log("Inside encrypt");
    var key = "$Gh0rm3hS8bz1B0st0n1979$$7iwt8lP37!@";
    let cipherData = AES.encrypt(value, key );
    //console.log("Encrypted Password is  "+cipherData.toString() );
    return  cipherData.toString();
  }
  
  //Begin Verify Code
  /* This was used for a dialog that I am not using any longer.
  onSubmitCodePressed() {
    this.sendNewCodeServer(DEFAULT_VESPAAN_SERVER.url,  this.state.newpasswordemail);
  }
  sendNewCodeServer( argURL, argEmail ){
    // const { navigate } = this.props.navigation;
    var self=this;
    if((argURL != null) || (argURL.length !== 0)){
      axios.all(self.getArrayOfNewCode(argURL, argEmail )).then(function(responses){
        console.log(responses[0].data);
        self.showNewCodeSuccess();
      }, function(err) {
        console.log(err);
        console.log("Some error occurred on new password request  to server " + err.message +  " the URL is " + argURL );
        self.errorMessage = err.response.data.message;
        self.showNewCodeError();
      });
    }
  }
  
  getArrayOfNewCode(argURL, argEmail){
    
    let baseUrl = argURL+"newpassword?email="+argEmail;
    console.log(" on newpassword request url  is " + baseUrl );
    
    var arrayOfGets = [];
    if(argURL != null) {
      
      arrayOfGets.push(axios.post(baseUrl, ));
    }
    return arrayOfGets;
  }
  */
  
  
  //End Verify Code
  
  
  
  handleResponseOkClose() {
    this.setState({ showResponseOkDialog: false });
    //this.setState({ showPasswordDialog: false });
    
  };
  
  showResponseOkClose() {
    this.setState({ showResponseOkDialog: true });
  };
  
  showCodeToCellphoneError() {
    this.setState({ showCodeToCellphoneErrorDialog: true });
  };
  handleNewPasswordErrorClose() {
    this.setState({ showCodeToCellphoneErrorDialog: false });
  };
  
  showNewCodeError() {
    this.setState({ showNewCodeErrorDialog: true });
  };
  handleNewCodeErrorClose() {
    this.setState({ showNewCodeErrorDialog: false });
  };
  
  
  showNewCodeSuccess() {
    this.setState({ showNewCodeSuccessDialog: true });
  };
  handleNewCodeSuccessClose() {
    this.setState({ showNewCodeSuccessDialog: false });
  };
  
  handleEmailChange(event) {
    //event.preventDefault();
    this.setState( { email: event.target.value });
  }
  
  handleServiceEmailChange(event) {
    //event.preventDefault();
    this.setState( { serviceEmail: event.target.value });
  }
  
  handlePasswordChange(event) {
    //event.preventDefault();
    this.setState( { password: event.target.value });
  }
  
  handleServicePasswordChange(event) {
    //event.preventDefault();
    this.setState( { servicePassword: event.target.value });
  }
 handleClickShowPassword(){
   
   this.setState( { showPassword: !this.state.showPassword });
 }
  
  handleClickShowServicePassword(){
    
    this.setState( { showServicePassword: !this.state.showServicePassword });
  }
  
  handleMouseDownPassword(){
    
    this.setState( { showPassword: !this.state.showPassword });
  }
  
  render() {
    const { classes, theme } = this.props;
    //const bull = <span className={classes.bullet}>•</span>;
    window.scrollTo(0, 0);
    return (
      <div id="top1"  style={{ backgroundColor:"#F2F6F8" }}>
        <Grid container spacing={24}  >
          <Grid   item xs={12} sm={12}  md={12} lg={12}   xl={12} >
            <div  style={{ marginLeft:15, marginRight:15,  marginTop:10}}>
              <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                {/*} <Typography component="h6" variant="h6"   style = { { textAlign: 'center', alignSelf: 'center' ,paddingTop:'0', marginTop:'0', fontWeight:'800', color:'#e2580d'}} >______________________________</Typography>
                <Typography component="h1" variant="h4"   style = { { textAlign: 'center', alignSelf: 'center' , fontWeight:'800', color:'#e2580d'}} >______________________________</Typography>*/}
              </Typography>
              <br/>
              <Typography component="h1" variant="h4"   style = { {  textAlign: 'center', alignSelf: 'center'  ,backgroundColor:'transparent' , color:'black'}} >Opt out from {MainConstants.APPLICATION_NAME} SMS Services
              </Typography>
              {/*<Typography component="h1" variant="h4"   style = { { textAlign: 'center', alignSelf: 'center' , fontWeight:'800', color:'#e2580d'}} >______________________________</Typography>
              
              <Typography component="h6" variant="h6"   style = { { textAlign: 'center', alignSelf: 'center' ,paddingTop:'0', marginTop:'0', fontWeight:'800', color:'#e2580d'}} >______________________________</Typography>*/}
              
              <br/>
              
              
              <Typography   variant="subtitle1">
                
                <br/>
                <br/>
                <div style = { { textAlign: 'center',alignSelf: 'center', fontWeight:'bold', fontSize:20, color:'#BF360C'}}>
                  <div><span style = { { textAlign: 'center', alignSelf: 'center' , fontWeight:'550', fontSize:26, color:'#BF360C'}} > Opt-Out from Promotional Communications</span></div>
                  <Typography component="h1" variant="h4"   style = { { textAlign: 'center', alignSelf: 'center' , fontWeight:'800', color:'#e2580d'}} >______________________________</Typography>
                  
                  <div style = { { textAlign: 'left',alignSelf: 'center', fontWeight:'bold', fontSize:20, color:'#BF360C'}}>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> We respect your preferences and understand that you may wish to limit the communications you receive from us. If you no longer want to
                        receive updates, promotions, or newsletters, you can easily opt out by filling out the form below and submit it.
                      We will send you a code to your smart phone, up on verification of that code you will be removed from our promotional communications.</span>
                    <Grid container>
                      
                      < Grid item xs={6} sm={6} md={2} lg={2}>
                        <InputMask mask="(999) 999-9999" value={this.state.cellphone}
                                   onChange={this.handleCellphoneChange}>
                          {() => < TextField  style = {{ marginTop:20,  marginLeft:10, marginRight:10, width:'71%',backgroundColor: "#d1e1e9"}} name="phone" label="Phone" fullWidth
                                              />}
                        </InputMask>
                      < /Grid>
                      
                      < Grid item xs={10} sm={10} md={10} lg={10}>
                      </Grid>
                      <Grid item xs={12} sm={12}  md={4} lg={4}  style = {{  alignContent:'center' }} >
                        <TextField id="email" name="email" label="Email"    style = {{ marginTop:20,  marginLeft:10, marginRight:10, width:'71%',backgroundColor: "#d1e1e9"}} fullWidth   value={this.state.email} onChange={this.handleEmailChange} />
                      </Grid>
                      < Grid item xs={0} sm={0} md={8} lg={8}>
                      </Grid>
                      
                      {/*} <Grid item xs={12} sm={12} md={4}  lg={4}   >
                        <TextField id="password" name="password" label="Password" style = {{ marginTop:10, marginLeft:10, marginRight:1, width:'71%', backgroundColor: "#d1e1e9",}} fullWidth  value={this.state.password} onChange={this.handlePasswordChange} />
                      </Grid>
                      */}
                      {/*} <Visibility/>
                      <VisibilityOff />*/}
                      <Grid item xs={12} sm={12} md={4}  lg={4}   >
                      <TextField
                        style = {{ marginTop:10, marginLeft:10, marginRight:1, width:'71%', backgroundColor: "#d1e1e9",}} fullWidth
                        label='Password'
                        //variant="outlined"
                        type={this.state.showPassword ? "text" : "password"} // <-- This is where the magic happens
                        onChange={this.handlePasswordChange}
                        InputProps={{ // <-- This is where the toggle button is added.
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={this.handleClickShowPassword}
                                
                              >
                                {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                      </Grid>
                      < Grid item xs={0} sm={0} md={8} lg={8}>
                      </Grid>
                      < Grid item xs={12} sm={12}>
                        <form onSubmit={this.handleOptoutForPromotional}>
                          
                          <ReCAPTCHA
                            //sitekey="6LdjmQ0rAAAAADU4GZUVtQmSXHSH-EBY11cjrAGx" // Replace with your actual site key
                            sitekey={MainConstants.RECAPTCHASITEKEY }
                            size="normal" // Use "invisible" for reCAPTCHA v3 or "normal" for v2
                            ref={this.recaptchaRefPromo}
                            onChange={this.handleCaptchaChangePromo}
                            badge="bottomright" // Adjust badge position as needed
                            className={classes.buttonrecaptcha} />
                          <Button size="large"  type='submit' variant="contained"    className={classes.button} >Submit</Button>
                        
                        </form>
                        {/*}
                        < Button
                          variant="contained"
                          color="primary"
                          onClick={this.handleOptoutForPromotional}
                          className={classes.button}>
                          Submit
                        < /Button>*/}
                        <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                          Note: The phone number must be the one you registered with {MainConstants.APPLICATION_NAME}.
                        </Typography>
                      < /Grid>
                    < /Grid>
                  </div>
                  <br/>
                  <br/>
                  <br/>
                  <div style = { { textAlign: 'center', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}>
                    <div>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Contact Us</span>
                    </div>
                    
                    
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> Please contact us if you have questions or concerns</span>
                    <div>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Email: </span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'blue'}}> Support@{MainConstants.APPLICATION_NAME}.com </span>
                      <div style = { { marginLeft:'20'}}>
                        {/*<span style = { { textAlign: 'left', alignSelf: 'left' ,   fontSize:18, color:'black'}}> Phone: </span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'blue'}}> (617) 939-6086 </span>*/}
                      </div>
                    </div>
                  </div>
                  <a href="/home"  rel="noreferrer"   style = { { textAlign: 'center', alignSelf: 'center'}}>
                    <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                      &lArr; Home
                    </Typography>
                  </a>
                  
                  <br/>
                  <br/>
                  <div><span style = { { textAlign: 'center', alignSelf: 'center' , fontWeight:'550', fontSize:26, color:'#BF360C'}} > Opt-Out from Service and Transactional Communications </span></div>
                  <Typography component="h1" variant="h4"   style = { {textAlign: 'center', alignSelf: 'center' , fontWeight:'800', color:'#e2580d'}} >______________________________</Typography>
                  
                  <div style = { { textAlign: 'left',alignSelf: 'center', fontWeight:'bold', fontSize:20, color:'#BF360C'}}>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> If you wish to discontinue your participation in {MainConstants.APPLICATION_NAME} Service, please fill
                      out the form below and submit.  We will send you a code to your smart phone, up on verification of that code you will be removed from our service communications.</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, fontWeight:'600',color:'red'}}> By opting out, you will no longer be part of {MainConstants.APPLICATION_NAME} Service,
                      you will NOT receive any alerts regarding your vehicle being towed, or any other service related communications. </span>
                     <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> Your associated data will be handled according to our privacy policy.
                      If you need assistance or have any questions, please contact our support team.</span>
                    <Grid container>
                      
                      < Grid item xs={6} sm={6} md={2} lg={2}>
                        <InputMask mask="(999) 999-9999" value={this.state.serviceCellphone}
                                   onChange={this.handleServiceCellphoneChange}>
                          {() => < TextField  style = {{ marginTop:20,  marginLeft:10, marginRight:10, width:'71%',backgroundColor: "#d1e1e9"}} name="phone" label="Phone" fullWidth
                          />}
                        </InputMask>
                      < /Grid>
                      
                      < Grid item xs={10} sm={10} md={10} lg={10}>
                      </Grid>
                      <Grid item xs={12} sm={12}  md={4} lg={4}  style = {{  alignContent:'center' }} >
                        <TextField id="email" name="email" label="Email"    style = {{ marginTop:20,  marginLeft:10, marginRight:10, width:'71%',backgroundColor: "#d1e1e9"}} fullWidth   value={this.state.serviceEmail} onChange={this.handleServiceEmailChange} />
                      </Grid>
                      < Grid item xs={0} sm={0} md={8} lg={8}>
                      </Grid>
                      
                      {/*<Grid item xs={12} sm={12} md={4}  lg={4}   >
                        <TextField id="password" name="password" label="Password" style = {{ marginTop:10, marginLeft:10, marginRight:1, width:'71%', backgroundColor: "#d1e1e9",}} fullWidth  value={this.state.servicePassword} onChange={this.handleServicePasswordChange} />
                      </Grid>*/}
                      
                      <Grid item xs={12} sm={12} md={4}  lg={4}   >
                        <TextField
                          style = {{ marginTop:10, marginLeft:10, marginRight:1, width:'71%', backgroundColor: "#d1e1e9",}} fullWidth
                          label='Password'
                          //variant="outlined"
                          type={this.state.showServicePassword ? "text" : "password"} // <-- This is where the magic happens
                          onChange={this.handleServicePasswordChange}
                          InputProps={{ // <-- This is where the toggle button is added.
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={this.handleClickShowServicePassword}
                                >
                                  {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                        />
                      </Grid>
                      
                      < Grid item xs={0} sm={0} md={8} lg={8}>
                      </Grid>
                      < Grid item xs={12} sm={12}>
                        
                        <form onSubmit={this.handleOptoutForService}>
                          
                          <ReCAPTCHA
                            //sitekey="6LdjmQ0rAAAAADU4GZUVtQmSXHSH-EBY11cjrAGx" // Replace with your actual site key
                            //sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                            sitekey={MainConstants.RECAPTCHASITEKEY }
                            size="normal" // Use "invisible" for reCAPTCHA v3 or "normal" for v2
                            ref={this.recaptchaRef}
                            onChange={this.handleCaptchaChange}
                            badge="bottomright" // Adjust badge position as needed
                            className={classes.buttonrecaptcha} />
                          <Button size="large"  type='submit' variant="contained"    className={classes.button} >Submit</Button>
                          
                        </form>
                        
                        
                        {/*} < Button
                          variant="contained"
                          color="primary"
                          onClick={this.handleOptoutForService}
                          className={classes.button}>
                          Submit
                        < /Button>*/}
                        <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                          Note: The phone number must be the one you registered with {MainConstants.APPLICATION_NAME}.
                        </Typography>
                      < /Grid>
                    < /Grid>
                  
                  </div>
                
                
                </div>
                
                {/*<div style = { {  fontWeight:'bold', fontSize:20, color:'#BF360C'}}>
                  <div><span style = { { textAlign: 'center', alignSelf: 'center' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Opt-Out of Service Participation</span></div>
                  <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> If you wish to discontinue your participation in PlateWiz Service, please click the link below to opt out:</span>
                  
                  <a href="/optout"   rel="noreferrer" style={{paddingLeft:10, display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
                    <Typography component="h2" variant="body1" style = { { color:'blue'}} >Opt out from service
                    </Typography>
                  </a>
                  <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> By opting out, you will no longer be part of PlateWiz Service, and your associated data will be handled according to our privacy policy.
                      If you need assistance or have any questions, please contact our support team.</span>
                
                </div>*/}
                <br/>
                <br/>
                <br/>
                <div style = { { textAlign: 'center', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}}>
                  <div>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontWeight:'bold', fontSize:20, color:'#BF360C'}} > Contact Us</span>
                  </div>
                  
                  
                  <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, fontWeight:'400',color:'black'}}> Please contact us if you have questions or concerns</span>
                  <div>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Email: </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'blue'}}> Support@{MainConstants.APPLICATION_NAME}.com </span>
                    <div style = { { marginLeft:'20'}}>
                      {/*<span style = { { textAlign: 'left', alignSelf: 'left' ,   fontSize:18, color:'black'}}> Phone: </span>
                      <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'blue'}}> (617) 939-6086 </span>*/}
                    </div>
                  </div>
                </div>
              
              </Typography> {/*End Of SMS Privacy Policy */}
              
              <a href="/home"  rel="noreferrer"   style = { { textAlign: 'center', alignSelf: 'center'}}>
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  &lArr; Home
                </Typography>
              </a>
              <br/>
              <br/>
              <br/>
            </div>
          </Grid>
        </Grid>
        
        <Dialog
          open={this.state.showResponseOkDialog}
          onClose={this.handleResponseOkClose}
          scroll={'paper'}
          classes={{
            paper: classes.formControl2,
          }}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          maxWidth="xl"
        >
          <DialogTitle id="scroll-dialog-title"> Successful </DialogTitle>
          <DialogContent id="farshids" dividers="paper">
            <div>
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
               You are opted out successfully.
              </Typography>
              {/*<Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                Please enter it here, and submit it.
              </Typography>*/}
              
              
              {/*} <InputMask mask="99-99-99" value={this.state.code}
                         onChange={this.handleCodeChange}>
                {() => < TextField required id="code" name="code" label="code" fullWidth
                                   InputLabelProps={{shrink: this.state.code}}/>}
              </InputMask>*/}
              {/*< TextField required id="code" name="code" label="Code" fullWidth
                          InputLabelProps={{shrink: this.state.inputFieldShrinkState}}/> */}
              {/*<Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                Thanks
              </Typography>*/}
            
            </div>
          </DialogContent>
          
          <DialogActions>
            <Button style = { {backgroundColor:'#e2580d'}} onClick={this.handleResponseOkClose} color="black">Ok</Button>
            {/*<Button style = { {backgroundColor:'#e2580d', paddingLeft:30}} onClick={this.onSubmitCodePressed} color="black">Submit Code</Button>*/}
          </DialogActions>
        
        
        
        </Dialog>
        <Dialog
          open={this.state.showCodeToCellphoneErrorDialog}
          onClose={this.handleNewPasswordErrorClose}
          scroll={'paper'}
          classes={{
            paper: classes.formControl2,
          }}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          maxWidth="xl"
        >
          <DialogTitle id="scroll-dialog-title" style = { { color:'red'}}>Failed!</DialogTitle>
          <DialogContent id="farshids" dividers="paper">
            <div>
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                The data you submitted was not right.
              </Typography>
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                Please make sure you entered the right cell phone number, username and password.
              </Typography>
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                Submit again.
              </Typography>
            </div>
          </DialogContent>
          <DialogActions>
            <Button  style = { {backgroundColor:'#e2580d'}} onClick={this.handleNewPasswordErrorClose} color="black">Ok</Button>
          </DialogActions>
        </Dialog>
        
        <Dialog
          open={this.state.showNewCodeSuccessDialog}
          onClose={this.handleNewCodeSuccessClose}
          scroll={'paper'}
          classes={{
            paper: classes.formControl2,
          }}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          maxWidth="xl"
        >
          <DialogTitle id="scroll-dialog-title">Code Verified!</DialogTitle>
          <DialogContent id="farshids" dividers="paper">
            <div>
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                New code was verified!
              </Typography>
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                You  cell phone is removed from our services.
              </Typography>
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                You will not be notified.
              </Typography>
              
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                Make sure you uninstall the {MainConstants.APPLICATION_NAME} app from you smart phone.
              </Typography>
            </div>
          </DialogContent>
          <DialogActions>
            <Button style = { {backgroundColor:'#e2580d'}} onClick={this.handleNewCodeSuccessClose} color="black">Ok</Button>
          </DialogActions>
        </Dialog>
        
        <Dialog
          open={this.state.showNewCodeErrorDialog}
          onClose={this.handleNewCodeErrorClose}
          scroll={'paper'}
          classes={{
            paper: classes.formControl2,
          }}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          maxWidth="xl"
        >
          <DialogTitle id="scroll-dialog-title">Wrong Code</DialogTitle>
          <DialogContent id="farshids" dividers="paper">
            <div>
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                Wrong code was entered!
              </Typography>
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                Please make sure you entered the right code
              </Typography>
              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                and submit again.
              </Typography>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleNewCodeErrorClose} color="black">Ok</Button>
          </DialogActions>
        </Dialog>
      </div>
    
    
    
    );
  }
}

const mapStateToProps = (state) => {
  return {
  
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    loginAction:loginAction,
    
    
  }, dispatch);
};


SaveTime.propTypes = {
  classes: PropTypes.object.isRequired,
};
//export default BiomassView;
//export default withStyles(styles, { withTheme: true })(SaveTime);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SaveTime));
